module.exports = __webpack_public_path__ + "img/percentage-square.4eca8174.svg";